import Page from './page';
import ReturnsNotification from '../components/common/returns-notification';
import SearchComponent from '../components/search/search-component';
import WkrTemplateNotification from '../components/common/wkr-template-notification';

export default class DashboardPage extends Page {
  private searchComponent?: SearchComponent;

  constructor(body: JQuery<HTMLBodyElement>) {
    super();
    ReturnsNotification.initAll();
    WkrTemplateNotification.initAll();

    const searchComponentEl = body[0].querySelector('.js-searchComponent');
    if (searchComponentEl) {
      this.searchComponent = new SearchComponent(searchComponentEl as HTMLElement);
    }
  }
}
